export default __webpack_public_path__ + "static/media/content_copy.95b0afa5.svg";